import React, { useMemo } from 'react'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

function useColumnPickingFlow({ onDelete }) {
  return useMemo(
    () => [
      {
        Header: t('PICKING_FLOW_SETTINGS.LIST.NAME'),
        accessor: 'Name',
        Cell: ({ value }) => value || '—',
      },
      {
        Header: t('PICKING_FLOW_SETTINGS.LIST.COMPANY'),
        accessor: 'CompanyName',
        Cell: ({ value }) => value || '—',
      },
      {
        Header: t('PICKING_FLOW_SETTINGS.LIST.ACTIONS'),
        accessor: 'actions',
        Cell: ({ row }) => (
          <div className="picking-flow-actions">
            <button
              onClick={() => onDelete(row.original)}
              data-testid={`btn-delete-picking-flow-branch-${row.original.BranchOfficeId}`}>
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ color: '#EF0909', fontSize: '2rem' }}
              />
            </button>
          </div>
        ),
      },
    ],
    [onDelete]
  )
}

export default useColumnPickingFlow
